// extracted by mini-css-extract-plugin
export default {"inputWrapper":"EmailInput_inputWrapper__QHqIq","label":"EmailInput_label__t9U2d","input":"EmailInput_input__vda9g","errorMessage":"EmailInput_errorMessage__EqSO5"};